"use strict";
(function(){
	const waitForElement = () => {
		if(!!window.VariantSwatchKing){
            // console.log("VariantSwatchKing loaded");

            setTimeout(function() {
              if($(".swatch-view-item").length > 0) {
                $(".swatch-view-item").each(function() {
                    $(this).attr("title", $(this).attr("orig-value"));   
                });
              }

              if($("body").find(".stock-info.csoon").is(":visible")) {

              	var swatchEL = $("body").find(".stock-info.csoon").parents(".card-wrapper").find("variant-swatch-king");
              	var quickAddBtn = $("body").find(".stock-info.csoon").parents(".card-wrapper").find(".quick-add.quick-view");
              	var quickAddBox = $("body").find(".stock-info.csoon").parents(".card-wrapper").find(".quick-add-box");

              	$(swatchEL).remove();
              	$(quickAddBtn).remove();
              	$(quickAddBox).remove();
              	
              }
            }, 1000);

            

          
          
		} else {
			requestAnimationFrame(waitForElement);
		}
	};
	waitForElement();
})();